//
// user.js
// Use this to write your custom JS
//
//切换年月
const toggles = document.querySelectorAll(
  '[data-toggle="product-card-button"]'
);
toggles.forEach((toggle) => {
  toggle.addEventListener("change", (e) => {
    const input = e.target;
    const isChecked = input.checked;

    const target = input.dataset.target;
    const targets = document.querySelectorAll(target);

    targets.forEach((target) => {
      const child = target.children;
      const child0 = child[0];
      const child1 = child[1];
      if (!isChecked) {
        child0.innerHTML = child0.dataset.month;
        child1.innerHTML = child1.dataset.month;
      } else {
        child0.innerHTML = child0.dataset.year;
        child1.innerHTML = child1.dataset.year;
      }
    });
  });
});
//点击卡片
// const cardArr = document.querySelectorAll('[data-target="product-card"]');
// cardArr.forEach((ele) => {
//   ele.addEventListener("click", (e) => {
//     const i = e.currentTarget.dataset.index;
//     if (i === "1") return;
//     // console.log(i);
//     cardArr.forEach((ele) => {
//       if (ele.dataset.index === "1") {
//         ele.setAttribute("data-index", i);
//       }
//     });
//     e.currentTarget.setAttribute("data-index", "1");
//   });
// });
